import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';
import * as dto from 'client/dto';
import { mapToNumericDictionary } from 'utils/arrayHelpers';
import { nameof } from 'utils/typeHelpers';

export type DiseaseActivitiesTemporalState = {
  isLoadingTemporalByDiseaseId: boolean;
  isLoadingTemporalByCountryId: boolean;
  temporalByDiseaseId: Record<number, dto.TemporalActivityModel[]>;
  temporalByCountryId: Record<number, dto.TemporalActivityModel[]>;
};

export const InitialDiseaseActivitiesTemporalState: DiseaseActivitiesTemporalState = {
  isLoadingTemporalByDiseaseId: false,
  isLoadingTemporalByCountryId: false,
  temporalByDiseaseId: {},
  temporalByCountryId: {},
};

const diseaseActivitiesTemporalSlice = createSlice({
  name: nameof<InsightsState>('diseaseActivitiesTemporal'),
  initialState: InitialDiseaseActivitiesTemporalState,
  reducers: {
    loadAllTemporalStart: state => {
      state.isLoadingTemporalByDiseaseId = true;
    },
    loadAllTemporalSuccess: (state, action: PayloadAction<dto.DiseaseTemporalActivityModel[]>) => {
      const temporalData = action.payload;
      state.isLoadingTemporalByDiseaseId = false;
      state.temporalByDiseaseId = mapToNumericDictionary(
        temporalData,
        d => d.diseaseId,
        d => d.temporalActivityList
      );
    },
    loadAllTemporalError: state => {
      state.isLoadingTemporalByDiseaseId = false;
    },
    loadDiseaseActivityTemporalStart: state => {
      state.isLoadingTemporalByCountryId = true;
    },
    loadDiseaseActivityTemporalSuccess: (
      state,
      action: PayloadAction<dto.CountryTemporalActivityModel[]>
    ) => {
      const temporalData = action.payload;
      state.isLoadingTemporalByCountryId = false;
      state.temporalByCountryId = mapToNumericDictionary(
        temporalData,
        d => d.countryDiseaseActivityKey?.countryId,
        d => d.temporalActivityList
      );
    },
    loadDiseaseActivityTemporalError: state => {
      state.isLoadingTemporalByCountryId = false;
    },
  },
});

const { actions, reducer } = diseaseActivitiesTemporalSlice;
export const {
  loadAllTemporalStart,
  loadAllTemporalSuccess,
  loadAllTemporalError,
  loadDiseaseActivityTemporalStart,
  loadDiseaseActivityTemporalSuccess,
  loadDiseaseActivityTemporalError,
} = actions;
export default reducer;
